import { ItnlIntegrationScript } from "@/data/types/ItnlIntegrationScript";
import { cartupInitScript, categoryIntroShowMoreScripts, klarnaRefreshExpressButton, klarnaRefreshPlacement, showMoreLessDescriptionScript } from "./itnlIntegrationScriptsScripts";
import { Settings } from "@/data/Settings";

export const getPageLoadScripts = (
    {
        ifKlarnaexists,
        settings
    }:
        {
            ifKlarnaexists: boolean
            settings: Settings
        }
) => {
    let scripts: ItnlIntegrationScript[] = [
        { scriptContent: cartupInitScript("9f630604-daa1-455d-aceb-a4150fa9127c"), id: "cartup_init_script" }, // TODO - REMOVE HARDCODED KEY - do not to get from settings
        { scriptContent: categoryIntroShowMoreScripts(), id: "category_intro_show_hide_script" },
        { scriptContent: showMoreLessDescriptionScript(), id: "show_more_less_description_script", delay: 2000 },
    ];
    if (ifKlarnaexists) {
        scripts.push(
            {
                url: settings.userData.Klarna_ExpressButtonEndPointURL,
                attrs: [['data-id', process.env.NEXT_PUBLIC_KLARNA_MERCHANT_ID ?? ''],
                ['data-environment', settings.userData.Klarna_Environment]],
                id: 'klarna_express_button',
                onLoadScripts: [
                    {
                        id: "page_klarna_refresh_button",
                        scriptContent: klarnaRefreshExpressButton()
                    }
                ],
                retainScript: true,
                skipIfExists: true
            },
            {
                url: settings.userData.Klarna_OnsiteMessagingEndPointURL,
                attrs: [['data-client-id', process.env.NEXT_PUBLIC_KLARNA_ONSITEMESSAGING_CLIENTID ?? '']],
                id: 'klarna_onsite_messaging',
                onLoadScripts: [
                    {
                        id: "klarna_onsitemessaging",
                        scriptContent: klarnaRefreshPlacement()
                    }
                ],
                retainScript: true,
                skipIfExists: true
            }
        );
    }
    return scripts;
}